<template>
  <div id="coin_dealer_level" class="coin_dealer_level">
     <!-- 顶部导航栏 -->
    <van-nav-bar placeholder safe-area-inset-top :title="$t('column.Coin_dealer_rule')" @click-left="onClickLeft" left-arrow />
    <van-row>
        <van-col span="22" offset="1" class="recharge-info-section">
          <!-- 30天充值信息 -->
          <van-col span="24" class="recharge-header">
            <van-col span="18" class="recharge-title-group">
              <van-col span="24" class="recharge-main-title">The recharges in recent 30 days</van-col>
              <van-col span="24" class="recharge-date-range">{{ recent_time }}</van-col>
            </van-col>
            <van-col span="6" class="recharge-amount">
              <img src="../assets/img/coin_dealer_level_coin.png" class="coin-icon-small"/>
              <span class="amount-value">{{ recharge_sum }}$</span>
            </van-col>
          </van-col>
          
          <!-- 等级升级信息 -->
          <van-col span="24" class="level-up-section">
            <van-col span="12" class="level-up-info">
              <van-col span="24" class="level-up-title">{{ $t('column.level_up') }}</van-col>
              <van-col span="24" class="level-up-need">
                {{ $t('column.still_need') }} 
                <img src="../assets/img/coin_dealer_level_coin.png" class="coin-icon-small"/>
                <span class="need-amount">{{ level_list[level_i] && level_list[level_i].still_need ? level_list[level_i].still_need : 0 }}$</span>
              </van-col>
            </van-col>
            <van-col span="12" class="current-level-badge">
              <div class="level-badge-wrapper" ref="badgeWrapper" @click="toggleLevelPopup">
                <img v-if="currentLevelImg" :src="currentLevelImg" class="level-badge-img"/>
                <van-icon name="arrow-down" class="badge-arrow"/>
              </div>
              <!-- 等级选择弹框 -->
              <div class="level-popup-container" v-show="showLevelPopup">
                <div class="level-popup">
                  <div class="level-popup-arrow"></div>
                  <div class="level-popup-list">
                    <div class="level-popup-item"
                         v-for="item in levelListArray"
                         :key="item.id"
                         v-if="level <= item.id"
                         @click.stop="selectLevel(item)">
                      <img :src="item.img" class="level-popup-item-img"/>
                    </div>
                  </div>
                </div>
              </div>
            </van-col>
          </van-col>
          
          <!-- 充值比例对比卡片 -->
          <van-col span="24" class="ratio-compare-cards">
            <van-col span="9" class="ratio-card ratio-card-left">
                <van-col span="24" class="ratio-text-img2">
                    <img src="../assets/img/coin10.png"/>
                </van-col>
               <van-col span="24" class="ratio-text2">1$={{ level_list[level_i] && level_list[level_i].current_rule ? level_list[level_i].current_rule : 0 }}</van-col>
            </van-col>
            <van-col span="14" class="ratio-card ratio-card-right" v-if="level_list[level_i] && level_list[level_i].next_rule">
                 <van-col span="24" class="ratio-text-img">
                    <img src="../assets/img/coin10.png"/>
                </van-col>
              <van-col span="24" class="ratio-text">1$={{ level_list[level_i].next_rule }}</van-col>
            </van-col>
          </van-col>
        </van-col>
      <van-col span="24" class="coin_dealer_level">
        <!-- 规则表格 -->
          <van-col span="24" class="rules-section">
            <van-col span="12" class="rules-title"  @click="rulesTab = 'DepositRules'">
              Marketing Channels
              <div :class="{'rules-title-active': rulesTab === 'DepositRules'}"></div>
            </van-col>
            <van-col span="12" class="rules-title" @click="rulesTab = 'LevelUpRules'">
              Level up & Privilege
              <div :class="{'rules-title-active': rulesTab === 'LevelUpRules'}"></div>
            </van-col>
          </van-col>
          <!-- 等级规则 -->
          <van-col span="24" class="rules-table" v-if="rulesTab === 'LevelUpRules'">
            <van-col span="22" offset="1" class="table-header">
              <van-col span="6" class="table-cell"></van-col>
              <van-col span="6" class="table-cell table-cell-bor">{{ $t('column.senior_seller')}}</van-col>
              <van-col span="6" class="table-cell table-cell-bor">{{ $t('column.standard_seller')}}</van-col>
              <van-col span="6" class="table-cell table-cell-bor">{{ $t('column.beginner_seller') }}</van-col>
            </van-col>
            <!-- 数据 -->
            <van-col span="22" offset="1" class="table-row-list">
              <van-col span="24" class="table-cell-title">Exchange Rate & Level-Up Recharge</van-col>
              <!--     exchange       -->
              <van-col  span="24" class="table-row">
                <van-col span="6" class="table-cell">
                  <van-col span="24" class="rule-name-color"> {{ $t('column.exchange') }} <img src="../assets/img/coin9.png"/></van-col>
                </van-col>
                <van-col span="6" class="table-cell table-cell-bor1">
                  1$={{ rulesData.exchange.senior_seller }} <img src="../assets/img/coin10.png"/>
                </van-col>
                <van-col span="6" class="table-cell table-cell-bor1">
                  1$={{ rulesData.exchange.standard_seller }} <img src="../assets/img/coin10.png"/>
                </van-col>
                <van-col span="6" class="table-cell table-cell-bor1">
                  1$={{ rulesData.exchange.beginner_seller }} <img src="../assets/img/coin10.png"/>
                </van-col>
              </van-col>
              <van-col  span="24" class="table-row">
                <van-col span="6" class="table-cell">
                  <van-col span="24" class="rule-name-color"> {{ $t('column.recharge') }} <img src="../assets/img/coin10.png"/></van-col>
                </van-col>
                <van-col span="6" class="table-cell table-cell-bor1">
                  ${{ rulesData.recharge.senior_seller }}
                </van-col>
                <van-col span="6" class="table-cell table-cell-bor1">
                  ${{ rulesData.recharge.standard_seller }}
                </van-col>
                <van-col span="6" class="table-cell table-cell-bor1">
                  $0
                </van-col>
              </van-col>

               <!--    营销渠道    -->
               <van-col span="24" class="table-cell-title"> Marketing Channels </van-col>
             
                <van-col  span="24" class="table-row">
                    <van-col span="6" class="table-cell rule-name1">any one to chat </van-col>
                    <van-col span="6" class="table-cell table-cell-bor1">
                      <van-icon name="checked" color="#FF61F5" size="20" v-if="rulesData.chat_permission.senior_seller"/>
                      <van-icon name="clear" color="#ACB0B4" size="20" v-else/>
                    </van-col>
                    <van-col span="6" class="table-cell table-cell-bor1">
                    <van-icon name="checked" color="#FF61F5" size="20" v-if="rulesData.chat_permission.standard_seller"/>
                    <van-icon name="clear" color="#ACB0B4" size="20" v-else/>
                    </van-col>
                    <van-col span="6" class="table-cell table-cell-bor1">
                    <van-icon name="checked" color="#FF61F5" size="20" v-if="rulesData.chat_permission.beginner_seller"/>
                    <van-icon name="clear" color="#ACB0B4" size="20" v-else/>
                    </van-col>
                </van-col>
                <van-col  span="24" class="table-row">
                    <van-col span="6" class="table-cell rule-name1"> whatsApps </van-col>
                    <van-col span="6" class="table-cell table-cell-bor1">
                    <van-icon name="checked" color="#FF61F5" size="20" v-if="rulesData.phone_permission.senior_seller"/>
                    <van-icon name="clear" color="#ACB0B4" size="20" v-else/>
                    </van-col>
                    <van-col span="6" class="table-cell table-cell-bor1">
                    <van-icon name="checked" color="#FF61F5" size="20" v-if="rulesData.phone_permission.standard_seller"/>
                    <van-icon name="clear" color="#ACB0B4" size="20" v-else/>
                    </van-col>
                    <van-col span="6" class="table-cell table-cell-bor1">
                    <van-icon name="checked" color="#FF61F5" size="20" v-if="rulesData.phone_permission.beginner_seller"/>
                    <van-icon name="clear" color="#ACB0B4" size="20" v-else/>
                    </van-col>
                </van-col>
                 <van-col  span="24" class="table-row">
                    <van-col span="6" class="table-cell rule-name1"> Price Banner </van-col>
                    <van-col span="6" class="table-cell table-cell-bor1">
                    <van-icon name="checked" color="#FF61F5" size="20" v-if="rulesData.price_banner_permission.senior_seller"/>
                    <van-icon name="clear" color="#ACB0B4" size="20" v-else/>
                    </van-col>
                    <van-col span="6" class="table-cell table-cell-bor1">
                    <van-icon name="checked" color="#FF61F5" size="20" v-if="rulesData.price_banner_permission.standard_seller"/>
                    <van-icon name="clear" color="#ACB0B4" size="20" v-else/>
                    </van-col>
                    <van-col span="6" class="table-cell table-cell-bor1">
                    <van-icon name="checked" color="#FF61F5" size="20" v-if="rulesData.price_banner_permission.beginner_seller"/>
                    <van-icon name="clear" color="#ACB0B4" size="20" v-else/>
                    </van-col>
                </van-col>





              <van-col span="24" class="table-cell-title">{{ $t('column.sales_methods') }}</van-col>
              <!--    sales methods      -->
              <van-col  span="24" class="table-row">
                <van-col span="6" class="table-cell rule-name1">
                  {{ $t('column.coin_seller')}} -> {{ $t('column.user')}}
                </van-col>
                <van-col span="6" class="table-cell table-cell-bor1">
                  <van-icon name="checked" color="#FF61F5" size="20" v-if="rulesData.sales_user.senior_seller"/>
                  <van-icon name="clear" color="#ACB0B4" size="20" v-else/>
                </van-col>
                <van-col span="6" class="table-cell table-cell-bor1">
                  <van-icon name="checked" color="#FF61F5" size="20" v-if="rulesData.sales_user.standard_seller"/>
                  <van-icon name="clear" color="#ACB0B4" size="20" v-else/>
                </van-col>
                <van-col span="6" class="table-cell table-cell-bor1">
                  <van-icon name="checked" color="#FF61F5" size="20" v-if="rulesData.sales_user.beginner_seller"/>
                  <van-icon name="clear" color="#ACB0B4" size="20" v-else/>
                </van-col>
              </van-col>
              <van-col  span="24" class="table-row">
                <van-col span="6" class="table-cell rule-name1">
                  {{ $t('column.coin_seller')}} -> {{ $t('column.coin_seller')}}
                </van-col>
                <van-col span="6" class="table-cell table-cell-bor1">
                  <van-icon name="checked" color="#FF61F5" size="20" v-if="rulesData.sales_coin_seller.senior_seller"/>
                  <van-icon name="clear" color="#ACB0B4" size="20" v-else/>
                </van-col>
                <van-col span="6" class="table-cell table-cell-bor1">
                  <van-icon name="checked" color="#FF61F5" size="20" v-if="rulesData.sales_coin_seller.standard_seller"/>
                  <van-icon name="clear" color="#ACB0B4" size="20" v-else/>
                </van-col>
                <van-col span="6" class="table-cell table-cell-bor1">
                  <van-icon name="checked" color="#FF61F5" size="20" v-if="rulesData.sales_coin_seller.beginner_seller"/>
                  <van-icon name="clear" color="#ACB0B4" size="20" v-else/>
                </van-col>
              </van-col>
              <van-col span="24" class="table-cell-title">{{ $t('column.privilege') }}</van-col>
              <!--   privilege     -->
              <van-col  span="24" class="table-row">
                <van-col span="6" class="table-cell rule-name1"> {{ $t('column.seller_list')}} </van-col>
                <van-col span="6" class="table-cell table-cell-bor1">
                  <van-icon name="checked" color="#FF61F5" size="20" v-if="rulesData.seller_list.senior_seller"/>
                  <van-icon name="clear" color="#ACB0B4" size="20" v-else/>
                </van-col>
                <van-col span="6" class="table-cell table-cell-bor1">
                  <van-icon name="checked" color="#FF61F5" size="20" v-if="rulesData.seller_list.standard_seller"/>
                  <van-icon name="clear" color="#ACB0B4" size="20" v-else/>
                </van-col>
                <van-col span="6" class="table-cell table-cell-bor1">
                  <van-icon name="checked" color="#FF61F5" size="20" v-if="rulesData.seller_list.beginner_seller"/>
                  <van-icon name="clear" color="#ACB0B4" size="20" v-else/>
                </van-col>
              </van-col>
              <van-col  span="24" class="table-row">
                <van-col span="6" class="table-cell rule-name1"> {{ $t('column.coin_selling_list')}} </van-col>
                <van-col span="6" class="table-cell table-cell-bor1">
                  <van-icon name="checked" color="#FF61F5" size="20" v-if="rulesData.coin_selling_list.senior_seller"/>
                  <van-icon name="clear" color="#ACB0B4" size="20" v-else/>
                </van-col>
                <van-col span="6" class="table-cell table-cell-bor1">
                  <van-icon name="checked" color="#FF61F5" size="20" v-if="rulesData.coin_selling_list.standard_seller"/>
                  <van-icon name="clear" color="#ACB0B4" size="20" v-else/>
                </van-col>
                <van-col span="6" class="table-cell table-cell-bor1">
                  <van-icon name="checked" color="#FF61F5" size="20" v-if="rulesData.coin_selling_list.beginner_seller"/>
                  <van-icon name="clear" color="#ACB0B4" size="20" v-else/>
                </van-col>
              </van-col>
              <van-col  span="24" class="table-row">
                <van-col span="6" class="table-cell rule-name1"> {{ $t('column.seller_tag')}} </van-col>
                <van-col span="6" class="table-cell table-cell-bor1">
                  <img :src="rulesData.seller_tag.senior_seller_tag" v-if="rulesData.seller_tag.senior_seller"/>
                  <van-icon name="clear" color="#ACB0B4" size="20" v-else/>
                </van-col>
                <van-col span="6" class="table-cell table-cell-bor1">
                  <img :src="rulesData.seller_tag.standard_seller_tag" v-if="rulesData.seller_tag.standard_seller"/>
                  <van-icon name="clear" color="#ACB0B4" size="20" v-else/>
                </van-col>
                <van-col span="6" class="table-cell table-cell-bor1">
                  <img :src="rulesData.seller_tag.beginner_seller_tag" v-if="rulesData.seller_tag.beginner_seller"/>
                  <van-icon name="clear" color="#ACB0B4" size="20" v-else/>
                </van-col>
              </van-col>
            </van-col>
            <van-col span="22" offset="1" class="table-row-usd">*{{ $t('column.recharge_with_usd') }}: $1= <img src="../assets/img/coin10.png"/> {{ recharge_usd_ratio }} </van-col>
          </van-col>
          <!-- 营销渠道 ADD coin_dealer_level_Channels -->
          <van-col span="24" class="rules-table" v-else>
             <van-col span="8" offset="8" class="channels-btn-wrapper">
               <button class="channels-btn" @click="handleAddChannels">ADD Channels</button>
             </van-col>
             <van-col span="22" offset="1">
               <div class="my-channels-header">
                 <span class="my-channels-title">My Channels</span>
                 <span class="my-channels-edit" @click="handleAddChannels">Edit</span>
               </div>
               <div class="channel-list">
                 <div class="channel-item" v-for="(item, index) in channelTypeColumns" :key="index" @click="editChannel(item)">
                   <div class="channel-info">
                     <div class="channel-title">{{ item.title }}</div>
                     <div class="channel-subtitle">
                       <template v-if="item.id === 1">Auto-reply {{ item.status == 1 ? 'on' : 'off' }}</template>
                       <template v-else-if="item.id === 2">Upload</template>
                       <template v-else-if="item.id === 3">{{ item.country_code ? '+' + item.country_code + ' ' : '' }}{{ item.text }}</template>
                     </div>
                   </div>
                   <div class="channel-action" @click.stop>
                     <template v-if="item.id === 2">
                       <div class="channel-banner-action">
                         <img v-if="item.text" :src="item.text" class="channel-banner-img" />
                       </div>
                     </template>
                      <template>
                         <van-switch v-model="item.status" :active-value="1" :inactive-value="2" size="16px" active-color="#00D282" inactive-color="#dcdee0" @change="handleStatusChange(item)"/>
                       </template>
                   </div>
                 </div>
               </div>
             </van-col>
          </van-col>
          
          <!-- 营销渠道 ADD Channels 弹框 -->
          <van-popup
            v-model="showChannelsPopup"
            :overlay="true"
            :close-on-click-overlay="true"
            @closed="resetChannelForm"
             class="channels-popup"
          >
            <div class="channels-popup-padding">
              <div class="channels-popup-header">
                <span class="popup-title">Add</span>
                <van-icon name="clear" @click="closeChannelsPopup" class="popup-close"/>
              </div>
              <div class="channels-popup-content">
                <!-- Select Type -->
                <div class="form-group">
                  <label class="form-label">Select Type</label>
                  <div class="custom-select-wrapper" :class="{'is-active': showDropdown}">
                    <div class="custom-select-trigger" @click="toggleDropdown">
                      <span class="select-value" :class="{'has-value': form.title}">
                        {{ form.title || 'Select' }}
                      </span>
                      <van-icon 
                        name="arrow" 
                        :class="{'rotate-icon': showDropdown}"
                      />
                    </div>
                    <transition name="dropdown-fade">
                      <div class="custom-dropdown" v-show="showDropdown">
                        <div 
                          class="dropdown-option"
                          v-for="option in channelTypeColumns"
                          :key="option.value"
                          @click="selectOption(option)"
                          :class="{'is-selected': form.id === option.id}"
                        >
                          {{ option.title }}
                          <van-icon 
                            name="success" 
                            v-if="form.id === option.id"
                            color="#FF61F5"
                          />
                        </div>
                      </div>
                    </transition>
                  </div>
                </div>
                
                <!-- Any one to chat 表单 -->
                <div class="form-group" v-if="form.id === 1">
                  <label class="form-label">{{ form.title }}</label>
                  <van-field
                    v-model="form.text"
                    type="textarea"
                    placeholder="your message......"
                    maxlength="200"
                    show-word-limit
                    rows="2"
                    class="vant-textarea"
                  />
                </div>
                
                <!-- Price banner 表单 -->
                <div class="form-group" v-if="form.id === 2">
                  <label class="form-label">{{ form.title }}</label>
                  <uploadImage
                    ref="uploader"
                    class="help_form_upload2"
                    :imageUrl="form.text"
                    :cos-config="cosConfig"
                    v-if="iscos"
                    @successUploadImage="handleSuccess"
                    @errorUploadImage="handleError"
                  />
                  <div class="upload-hint">Upload rules: Images can only be uploaded in JPG/PNG format; Size: 710px X 188px</div>
                </div>
                
                <!-- WhatsApp number 表单 -->
                <div class="form-group" v-if="form.id === 3">
                  <label class="form-label">{{ form.title }}</label>
                  <van-field
                    v-model="form.text"
                    type="tel"
                    placeholder="Enter phone number"
                    class="vant-phone-input"
                    @input="filterNumbers"
                  >
                    <template #label>
                      <span @click="showCountryPopup = true">
                        <img :src="form.flag" alt="" class="country-flag1"/>
                        + {{ form.country_code }}</span>
                    </template>
                  </van-field>
                </div>
                
                <!-- Confirm 按钮 -->
                 <div class="form-group-btn">
                    <van-button
                      type="primary"
                      block
                      @click="confirmChannelAdd"
                      class="vant-confirm-btn"
                    >
                      Confirm
                    </van-button>
                 </div>
               
              </div>
            </div>
          </van-popup>

          <!-- 国家区号选择弹框 -->
          <van-popup
            v-model="showCountryPopup"
            position="bottom"
            round
            :style="{ height: '60%' }"
            class="country-popup"
          >
            <div class="country-popup-header">
              <span class="popup-title">Select Country/Region</span>
              <van-icon name="clear" @click="showCountryPopup = false" class="popup-close"/>
            </div>
            <div class="country-search">
              <van-search v-model="searchCountry" placeholder="Search" />
            </div>
            <div class="country-list">
              <van-cell
                v-for="(item, index) in filteredCountryDial"
                :key="index"
                @click="selectCountry(item)"
              >
                <template #title>
                  <img :src="item.flag" alt="" class="country-flag"/>
                  <span class="country-name">{{ item.en_short_name }}</span>
                </template>
                <template #right-icon>
                  <span class="country-code">+{{ item.dial_code }}</span>
                </template>
              </van-cell>
            </div>
          </van-popup>
          
      </van-col>
    </van-row>
  </div>
</template>

<script>

import '@/assets/css/style.css'
import axios from "axios";
import {Toast, Dialog} from "vant";
import UploadImage from "./upload_image.vue";

export default {
  components: {UploadImage},
  data() {
    return {
        rulesTab: 'LevelUpRules',
        level: 1,
        level_list: [],
        level_i: 1,
        recent_time: '',
        recharge_sum: 0,
        rulesData:{
            chat_permission:{
                 senior_seller:0,
                standard_seller:0,
                beginner_seller:0
            },
            phone_permission:{
                 senior_seller:0,
                standard_seller:0,
                beginner_seller:0
            },
            price_banner_permission:{
                 senior_seller:0,
                standard_seller:0,
                beginner_seller:0
            },
            exchange:{
                 senior_seller:0,
                standard_seller:0,
                beginner_seller:0
            },
            recharge:{
                 senior_seller:0,
                standard_seller:0,
                beginner_seller:0
            },
            sales_user:{
                senior_seller:0,
                standard_seller:0,
                beginner_seller:0
            },
             sales_coin_seller:{
                senior_seller:0,
                standard_seller:0,
                beginner_seller:0
            },
            seller_list:{
                senior_seller:false,
                standard_seller:false,
                beginner_seller:false
            },
            customer_recommend_list:{
                senior_seller:false,
                standard_seller:false,
                beginner_seller:false
            },
            coin_selling_list:{
                senior_seller:false,
                standard_seller:false,
                beginner_seller:false
            },
            seller_tag:{
                senior_seller:false,
                standard_seller:false,
                beginner_seller:false,
                senior_seller_tag:'',
                standard_seller_tag:'',
                beginner_seller_tag:''
            }
        },
        showLevelPopup: false,
        deposit_rules:'',
        recharge_usd_ratio:'',
        // ADD Channels 弹框相关数据
        showChannelsPopup: false,
        showDropdown: false,
        showPicker: false,
        showCountryPopup: false,
        searchCountry: '',
        channelTypeColumns: [],
        form: {
          'id': 1,
          'title': '',
          'text': '',
          'country_code': '',
          'flag': ''
        },
        cosConfig: {
          tmpSecretKey: undefined,
          tmpSecretId: undefined,
          bucket: undefined,
          region: undefined,
          sessionToken: '',
          domain: '',
        },
        iscos: false,
        country_dial: [],
    }
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside);
  },
  computed: {
    levelListArray() {
      if (Array.isArray(this.level_list)) {
        return this.level_list;
      }
      return Object.values(this.level_list || {});
    },
    currentLevelImg() {
      const item = this.levelListArray.find(item => item.id === this.level_i);
      return item ? item.img : '';
    },
    filteredCountryDial() {
      const list = Array.isArray(this.country_dial) ? this.country_dial : Object.values(this.country_dial || {});
      if (!this.searchCountry) {
        return list;
      }
      const lowerSearch = this.searchCountry.toLowerCase();
      return list.filter(item => 
        (item.en_short_name && item.en_short_name.toLowerCase().includes(lowerSearch)) ||
        (item.dial_code && item.dial_code.toString().includes(lowerSearch))
      );
    }
  },
  created() {
    this.get_list()
    this.getcosConfig()
  },
  methods: {
     getcosConfig(){
      const uid = this.$route.query.uid
      const token = this.$route.query.token
      axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=app&act=getCosSTS",{ params:{ uid: uid, token: token }}).then(res =>{
        console.log(res.data)
        if(res.data.status===1){
          this.cosConfig = res.data.data.sts
          this.iscos = true
        }else{
          this.$emit('errorUploadImage', res.data.error)
        }
      })
    },
    handleSuccess(url) {
      // 上传成功
      this.form.text = url
    },
    handleError(err) {
      console.log('====handleError====')
      // 上传失败
      Toast(err);
    },
    onClickLeft() {
      this.$router.go(-1)
    },
    toggleLevelPopup() {
      console.log('点击了等级badge，当前showLevelPopup:', this.showLevelPopup);
      this.showLevelPopup = !this.showLevelPopup;
    },
    selectLevel(item) {
      console.log('选中等级:', item.id);
      this.level_i = item.id;
      this.showLevelPopup = false;
    },
    handleClickOutside(event) {
      // 关闭等级弹框
      if (this.showLevelPopup) {
        const popupContainer = this.$el.querySelector('.level-popup-container');
        const badgeWrapper = this.$el.querySelector('.level-badge-wrapper');
        if (popupContainer && !popupContainer.contains(event.target) && badgeWrapper && !badgeWrapper.contains(event.target)) {
          this.showLevelPopup = false;
        }
      }
      // 关闭下拉框
      if (this.showDropdown) {
        const selectWrapper = this.$el.querySelector('.custom-select-wrapper');
        if (selectWrapper && !selectWrapper.contains(event.target)) {
          this.showDropdown = false;
        }
      }
    },
    handleAddChannels() {
      console.log('点击 ADD Channels 按钮');
      this.showChannelsPopup = true;
      this.resetChannelForm();
    },
    closeChannelsPopup() {
      this.showChannelsPopup = false;
    },
    editChannel(item) {
      this.form = Object.assign({
        text: '',
        country_code: '',
        flag: ''
      }, item);
      this.showChannelsPopup = true;
    },
    resetChannelForm() {
      this.form = {
        id: 1,
        text: '',
        country_code: '',
        flag: ''
      };
      this.showDropdown = false;
      this.showPicker = false;
    },
    toggleDropdown() {
      this.showDropdown = !this.showDropdown;
    },
    selectOption(value) {
      console.log(value)
      
      // 重置表单并确保存在响应式属性
      this.form = Object.assign({
        text: '',
        country_code: '',
        flag: ''
      }, value);
      this.showDropdown = false;
    },
    getFlagEmoji(countryCode) {
      if (!countryCode) return '';
      return countryCode.toUpperCase().replace(/./g, char => 
        String.fromCodePoint(char.charCodeAt(0) + 127397)
      );
    },
    selectCountry(item) {
      this.form.country_code = item.dial_code;
      this.form.flag =item.flag;
      this.showCountryPopup = false;
      this.searchCountry = '';
    },

    filterNumbers(value) {
      // 过滤非数字字符，只保留数字
      this.form.text = value.replace(/[^\d]/g, '');
    },
    handleStatusChange(item) {
      const toast = this.$toast.loading({
        duration: 0,
        forbidClick: true,
        message: this.$t('other.Loading') + '...',
        className: 'custom-loading-toast'
      });
      const uid = this.$route.query.uid;
      const token = this.$route.query.token;
      
      const status = (item.status === true || item.status == 1) ? 1 : 2;

      axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=coin_seller&act=save_coin_dealer_channel_status", {
        params: {
          uid: uid,
          token: token,
          id: item.id,
          status: status
        }
      }).then(res => {
        toast.clear();
        if (res.data.status != 1) {
          Toast(res.data.error);
          // Revert status
          item.status = (status === 1) ? 2 : 1;
        }
      }).catch(err => {
        toast.clear();
        Toast('Network Error');
        // Revert status
        item.status = (status === 1) ? 2 : 1;
      });
    },
    confirmChannelAdd() {
      // TODO: 提交表单数据到后端
      console.log('Selected Type:', this.form.id);
      
      if (this.form.id === 1) {
        if (!this.form.text.trim()) {
          this.$toast.fail('Please enter auto-reply message');
          return;
        }
        console.log('Auto-reply message:', this.form.text);
      } else if (this.form.id === 2) {
        if (!this.form.text.trim()) {
          this.$toast.fail('Please upload price banner');
          return;
        }
        console.log('Upload file:', this.form.text);
      } else if (this.form.id === 3) {
        if (!this.form.text.trim()) {
          this.$toast.fail('Please enter WhatsApp number');
          return;
        }
        console.log('WhatsApp number:', this.form.country_code, this.form.text);
      }
      const toast = this.$toast.loading({
        duration: 0, // 持续展示
        forbidClick: true,
        message: this.$t('other.Loading') + '...',
        className: 'custom-loading-toast' // 添加自定义类名
      });
      const uid = this.$route.query.uid
      const token = this.$route.query.token
      axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=coin_seller&act=save_coin_dealer_channel",{ 
        params:{ 
          uid: uid, 
          token: token,
          id: this.form.id,
          text: this.form.text,
          country_code: this.form.country_code,
        }
      }).then(res =>{
        toast.clear(); // 关闭加载提示
        console.log(res.data)
        Toast(res.data.error)
        if(res.data.status===1){
          this.get_list()
          this.closeChannelsPopup()
        }
      })
    },
     get_list(){
      const toast = this.$toast.loading({
        duration: 0, // 持续展示
        forbidClick: true,
        message: this.$t('other.Loading') + '...',
        className: 'custom-loading-toast' // 添加自定义类名
      });
      const uid = this.$route.query.uid
      const token = this.$route.query.token
      axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=coin_seller&act=coin_dealer_level_ruler",{
        params:{uid: uid, token: token }
      }).then(res =>{
        toast.clear(); // 关闭加载提示
        console.log(res.data)
        if(res.data.status===1){
          this.rulesData = res.data.data.level_up_rules
          this.deposit_rules = res.data.data.deposit_rules
          this.recharge_usd_ratio = res.data.data.recharge_usd_ratio
          this.level = res.data.data.level,
          this.level_list = res.data.data.level_list
          this.level_i = res.data.data.level
          this.recent_time = res.data.data.recent_time
          this.recharge_sum = res.data.data.recharge_sum
          this.channelTypeColumns = res.data.data.channelTypeColumns
          this.country_dial = res.data.data.country_dial
        }else{
          Toast(res.data.error)
        }
      })
    }
  }
}

</script>

<style scoped>

.country-popup {
  display: flex;
  flex-direction: column;
}
.country-popup-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 20px;
  font-size: 16px;
  font-weight: bold;
  border-bottom: 1px solid #f5f5f5;
}
.country-search {
  padding: 10px;
}
.country-list {
  flex: 1;
  overflow-y: auto;
}
.country-flag {
  height: 3vw;vertical-align: middle;
}
.country-flag1 {
  height: 3vw;
}
.country-name {
  font-size: 14px;
}
.country-code {
  color: #999;
}

.my-channels-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 0 10px;
}
.my-channels-title {
  font-size: 0.9rem;
  color: #666;
}
.my-channels-edit {
  font-size: 14px;
  color: #666;
}
.channel-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.channel-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.05);
}
.channel-info {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.channel-title {
  font-weight: bold;
  color: #333;
  margin-bottom: 5px;
}
.channel-subtitle {
  font-size: 0.8rem;
  color: #999;
}
.channel-action {
  display: flex;
  align-items: center;
}
.channel-banner-action {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-right: 2vw;
}
.channel-banner-img {
  height: 30px;
  border-radius: 4px;
}

</style>



// WEBPACK FOOTER //
// src/components/coin_dealer_level.vue